import {createTheme} from "@mui/material";

declare module '@mui/material/styles' {
  interface Palette {
    contrast: Palette['primary'];
    container: Palette['primary'];
    footer: Palette['primary'];
    stepper: Palette['primary'];
  }

  // allow configuration using `createTheme`
  interface PaletteOptions {
    contrast?: PaletteOptions['primary'];
    container?: PaletteOptions['primary'];
    footer?: PaletteOptions['primary'];
    stepper?: PaletteOptions['primary'];
  }

  interface PaletteColor {
    contrast?: string;
    container?: string;
    footer?: string;
    stepper?: string;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    contrast: true;
  }
}

// https://zenoo.github.io/mui-theme-creator/
export const theme = createTheme( {
  palette: {
    mode: 'light',
    primary: {
      main: '#2D0067',
      contrastText: '#E3E4FF',
    },
    contrast: {
      main: '#E3E4FF',
      contrastText: '#2D0067',
    },
    footer: {
      main: '#E1E2E6',
      contrastText: '#2D0067',
    },
    container: {
      main: '#DFFFF9',
      contrastText: '#2D0067',
    },
    stepper: {
      main: '#E3E4FF',
      contrastText: '#2D0067',
    },
    secondary: {
      main: '#B8FFEE',
      contrastText: '#2D0067',
    },
    text: {
      primary: '#2D0067',
    },
    divider: '#2D0067',
    background: {
      default: '#FFF',
    },
  },
  shape: {
    borderRadius: 4,
  },
  typography: {
    h1: {
      fontWeight: 600,
      fontSize: 88,
    },
    h3: {
      fontWeight: 300,
      fontSize: 48,
    },
    h4: {
      fontWeight: 600,
      fontSize: 32,
    },
    h2: {
      fontWeight: 500,
      fontSize: 64,
    },
    fontFamily: 'Epilogue',
    h5: {
      fontSize: 32,
    },
    h6: {
      fontWeight: 400,
    },
    overline: {
      fontSize: 24,
      letterSpacing: 2.3
    },
    body1: {
      fontSize: 16,
      lineHeight: 1.43,
    },
    body2: {
      fontWeight: 600,
      fontSize: 16,
    },
    fontWeightBold: 600,
  },
});